/* eslint-disable */
export class Debounce {
  private _timer: NodeJS.Timer | number | null = null;

  constructor(private readonly _time = 100) {}

  public invoke(fn: () => void): void {
    if (this._timer) {
      clearTimeout(this._timer as NodeJS.Timer);
    }

    this._timer = setTimeout(() => {
      this._timer = null;
      fn();
    }, this._time);
  }
}
